<template>
  <q-layout>
    <q-page-container>
  <q-page class="bg-primary window-height window-width row justify-center items-center">
    <div class="column">

      <div class="row">
        <q-form
            @submit="onSubmit"
            @reset="onReset"
            class="q-gutter-md"
            :class='{ "q-gutter-md" : true, "q-py-xl" : this.embed }'
        >
        <q-card  class="q-pa-lg">
          <q-card-section>

              <h5 class="text-h5 q-my-md">Sign up</h5>
              <q-input square filled  v-model="email" label="email"

                       :rules=" [

            val => !!val || '* Required',
            val => val.length > 4 || 'Please use minimum 5 chars',
            val => isValidEmail() || 'Please type valid email address'

            ]"
                       :disable="isSending"
              >
                <template v-slot:append>
                  <q-icon name="s_email" />
                </template>
              </q-input>
              <q-input square filled  v-model="first_name" label="first name"
                       :rules="[ val => val && val.length > 0 || 'First Name is required']"
                       :disable="isSending"
              />
              <q-input square filled  v-model="last_name" label="last name"
                       :rules="[ val => val && val.length > 0 || 'Last Name is required']"
                       :disable="isSending"
              />
              <q-input square filled  v-model="password" label="password"
                       :rules="[ val => val && val.length > 0 || 'Password is required', val => isValidPassword() || 'Password is not secure']"
                       :type="isPwd ? 'password' : 'text'"
                       :disable="isSending"
                       :hide-bottom-space="true"
              >

                <template v-slot:append>
                  <q-icon
                      :name="isPwd ? fasEye : fasEyeSlash"
                      class="cursor-pointer"
                      @click="isPwd = !isPwd"
                  />
                </template>
              </q-input>
            <div class="password_hint">
              <div>Password should contain:</div>
              <div>At least one uppercase letter</div>
              <div>At least one lowercase letter</div>
              <div>At least one digit</div>
              <div>At least one special symbol</div>
              <div>should be more than 8 character</div>
            </div>

          </q-card-section>
          <q-card-actions class="q-px-md">
            <q-btn :loading="isSending" unelevated type="submit" color="primary" size="lg" class="full-width" label="Sign Up" />
          </q-card-actions>
          <q-card-section class="text-center q-pa-none" v-if="!isSending">
            <p class="text-grey-6">Already have an account?  <router-link to="/login" class="text-primary text-decoration-none">
              <span class="text-weight-bolder ">Sign In</span>
              </router-link>
            </p>
          </q-card-section>
        </q-card>
        </q-form>
      </div>

    </div>
    <q-dialog v-model="showEmailModal" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">Verify your email</div>
          <div class="text">Please enter 4-digit code sent to</div>
          <div class="text">{{email}}</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <q-input  mask="#-#-#-#" fill-mask="#" unmasked-value dense v-model="emailConfirmCode" autofocus @keyup.enter="showEmailModal = false" />

        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Cancel" v-close-popup @click="isSending = false; emailConfirmCode = ''"/>
          <q-btn :disable="!isValidEmailCode()" flat label="Confirm" v-close-popup @click="this.register();"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>

      </q-page-container>
        </q-layout>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import {fasEye,fasEyeSlash} from "@quasar/extras/fontawesome-v5"
import {fetchEnv, getRedirectParam} from "@/helpers/form";
import {Loading, Notify} from "quasar";
import {mapActions} from "vuex";

export default {
  name: 'RegisterComponent',
  data () {
    return {
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      isSending: false,
      isPwd: true,
      fasEye,
      fasEyeSlash,
      showEmailModal: false,
      emailConfirmCode: '',
      embed: false
    }
  },
  computed: {
    ...mapFields('settings/list', {
      form: 'form'
    })
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.embed = urlParams.get('embed');
    this.initResize();
  },
  created () {
    this.fasEye = fasEye;
    this.fasEyeSlash = fasEyeSlash;
  },
  methods: {
    ...mapActions({
      authenticateUser: 'settings/list/authenticateUser',
    }),
    isValidEmailCode() {
      return this.emailConfirmCode.length === 4;
    },
    onSubmit () {
      this.isSending = true;
      this.confirmEmail();
    },
    async confirmEmail() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('register')
      this.isSending = true;
      fetchEnv('/front/api/v1/email/confirm', {
        token,
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name,
        password: this.password,
        code: this.emailConfirmCode
      })
          .then(
              (response) => {
                this.isSending = false;
                if(response.success === undefined || !response.success) {
                  let errorBlock = '';
                  for(let key in response.error) {
                    errorBlock += '<p style="color: red">'+response.error[key]+'</p>';
                  }
                  Notify.create(  //'Something went wrong');
                      {
                        message: '<p><em>Something went wrong</em></p>' + errorBlock,
                        html: true,
                        timeout:5000
                      });
                  //console.log(response);
                } else {
                  this.showEmailModal = true;
                }
              })
          .catch(error => console.log(error));
    },
    async register() {
      if(!this.isValidEmailCode()) {
        return;
      }

      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('register')
      this.isSending = true;
      fetchEnv('/front/api/v1/register', {
        token,
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name,
        password: this.password,
        code: this.emailConfirmCode
      })
          .then(
              (response) => {
                this.isSending = false;
                if(response.authenticated === undefined || !response.authenticated) {
                  let errorBlock = '';
                  for(let key in response.error) {
                    errorBlock += '<p style="color: red">'+response.error[key]+'</p>';
                  }
                  Notify.create(  //'Something went wrong');
                      {
                        message: '<p><em>Something went wrong</em></p>' + errorBlock,
                        html: true,
                        timeout:5000
                      });
                  this.showEmailModal = false;
                  this.emailConfirmCode = '';
                  //console.log(response);
                } else {
                  //Notify.create('Submitted');
                  this.authenticateUser(response);
                  this.isSent = true;
                  Loading.show({group: 'redirect'});
                  getRedirectParam().then(redirectData => {
                    if(Object.hasOwn(redirectData,'redirect') && redirectData.redirect !== undefined  && redirectData.redirect) {
                      document.location = redirectData.redirect;
                    } else {
                      Loading.hide('redirect');
                      this.$router.push('/forms');
                    }
                  });
                }
              })
          .catch(error => console.log(error));
    },
    onReset () {

    },
    isValidEmail() {
      try {
        //eslint-disable-next-line
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email);
      } catch (e) {
        console.log(e);
      }
      return false;
    },
    isValidPassword() {
        return /[A-Z]/       .test(this.password) &&
            /[a-z]/       .test(this.password) &&
            /[0-9]/       .test(this.password) &&
            /[^A-Za-z0-9]/.test(this.password) &&
            this.password.length > 8;
      },
    initResize () {
      // create an Observer instance
      const resizeObserver = new ResizeObserver(() => {
            //console.log('Body height changed:', entries[0].target.clientHeight);
            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id');
            const message = JSON.stringify({
              message: 'resize',
              id: id,
              scrollHeight: document.body.scrollHeight
            });
            window.parent.postMessage(message, '*');
          }
      )
      resizeObserver.observe(document.body);
    }
  }
}
</script>

<style scoped>
.q-card {
  width: 360px;
}
.text-decoration-none {
  text-decoration: none;
}
.password_hint {
  font-size: 12px;
  padding-left: 12px;
  margin-top: 12px;
}
</style>